import { ToListButton } from './styles';
import {useTranslation} from "react-i18next";

export default function ToList() {
    const handleClick = () => {
        // Возврат к списку
        window.location.href = 'https://seafoodexporussia.com/exhibitors/index_2026.php';
    };
    const { t } = useTranslation();

    return (
        <ToListButton onClick={handleClick}>
            {t("ToList")}
        </ToListButton>
    );
}